export default "__VITE_ASSET__ChyeiqU3__"